// extracted by mini-css-extract-plugin
export default {"header":"DefaultHeader_header__NejWo","inner":"DefaultHeader_inner__25C0w","link":"DefaultHeader_link__5x+3K","activeLink":"DefaultHeader_activeLink__sdqLa"};